import { createBrowserRouter } from "react-router-dom";

// Layout components
import RootLayout from "../layouts/RootLayout";

// Page components
import HomePage from "../pages/home";
import AboutPage from "../pages/about";
import ExpertisePage from "../pages/expertise";
import BlogPage from "../pages/blog";
import BlogPostPage from "../pages/blog/$slug";
import ContactPage from "../pages/contact";
import FirmPage from "../pages/firms/[slug]";
import NotFoundPage from "../pages/common/NotFoundPage";
import ProjectDetail from "../pages/firms/ProjectDetail";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    errorElement: <NotFoundPage />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: "about",
        element: <AboutPage />,
      },
      {
        path: "expertise",
        element: <ExpertisePage />,
      },
      {
        path: "blog",
        element: <BlogPage />,
      },
      {
        path: "blog/:slug",
        element: <BlogPostPage />,
      },
      {
        path: "contact",
        element: <ContactPage />,
      },
      {
        path: "firms/:slug",
        element: <FirmPage />,
      },
      {
        path: "firms/:firmSlug/projects/:projectSlug",
        element: <ProjectDetail />,
      },
    ],
  },
]);
